import { sessionTakingsAud } from '@atink/domain';
import type { Artist, Booking, SalePayment } from '@/domain/types';

/**
 * The store-side reads of the ONE session price rule (@atink/domain
 * `sessionTakingsAud`, B1): envelopes, arrears, the Day sheet and Reporting all
 * price a session through here, so no screen can disagree with another.
 */

/**
 * Sales indexed by the booking they settle (a sale's own id is not always
 * `sale-<bookingId>`). Should a booking carry more than one, the latest wins —
 * the same pick the server's day rollover makes, so both price it alike.
 */
export function salesByBookingId(salePayments: Record<string, SalePayment>): Map<string, SalePayment> {
  const map = new Map<string, SalePayment>();
  const ordered = Object.values(salePayments).sort(
    (a, b) => Date.parse(a.takenAt) - Date.parse(b.takenAt) || a.id.localeCompare(b.id),
  );
  for (const s of ordered) map.set(s.bookingId, s);
  return map;
}

/** A session's commissionable takings: its sale, else what was paid, else its booked price. */
export function sessionTakingsFor(
  b: Booking,
  sales: Map<string, SalePayment>,
  artists: Record<string, Partial<Pick<Artist, 'rates'>> | undefined>,
): number {
  const rates = artists[b.artistId]?.rates;
  // No usable rate card (as on the server): the booked day rate or $0.
  return sessionTakingsAud(b, sales.get(b.id), rates?.smallAud != null ? { rates } : undefined);
}
